<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="TITLE">The Election of Grace</p>
<p class="SUBTITLE">A Riddle without a Resolution?</p>
<p class="AUTHOR">Stephen N. Williams</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan / Cambridge, U.K.</p>
<p class="COPYRIGHT">© 2015 Stephen N. Williams<br/>All rights reserved<br/><br/>Published 2015 by<br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge CB3 9PU U.K.<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Williams, Stephen N. (Stephen Nantlais)<br/>The election of grace: a riddle without a resolution? / Stephen N. Williams.<br/>pages   cm<br/>Includes index.<br/>ISBN 978-0-8028-3780-6 (pbk.: alk. paper)<br/>eISBN 978-1-4674-4327-2 (ePub)<br/>eISBN 978-1-4674-4287-9 (Kindle)<br/>1. Election (Theology) I. Title.<br/><br/>BT810.3.W55 2015<br/>234 — dc23<br/>                2014041181</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Williams_The_Election_of_Grace_text_CC-2.vue?71bc8440